import { Configuration } from '@/lib/Configuration';
import { ConfigurationType } from '@/models/enums';

export class ConfigurationHelper {
  public getChassis(configurations: Configuration[]): Configuration {
    return this.getConfiguration(configurations, ConfigurationType.Chassis);
  }

  public getBody(configurations: Configuration[]): Configuration {
    return this.getConfiguration(configurations, ConfigurationType.Body);
  }

  public getAxle(configurations: Configuration[]): Configuration {
    return this.getConfiguration(configurations, ConfigurationType.Axle);
  }

  public getBrake(configurations: Configuration[]): Configuration {
    return this.getConfiguration(configurations, ConfigurationType.Brake);
  }

  public getContainer(configurations: Configuration[]): Configuration {
    return this.getConfiguration(configurations, ConfigurationType.Container);
 }

  public getAuxiliaries(configurations: Configuration[]): Configuration[] {
    if (!configurations || configurations.length == 0) { return new Array(new Configuration()); }
    let auxiliaryConfigurations = configurations.filter(x => x.type == ConfigurationType.Auxiliary);
    if (auxiliaryConfigurations.length == 0) { return new Array(new Configuration()); }
    return auxiliaryConfigurations;
  }

  private getConfiguration(configurations: Configuration[], configurationType: ConfigurationType) {
    if (!configurations || configurations.length == 0) { return new Configuration(); }
    let configuration = configurations.filter(x => x.type == configurationType);
    if (configuration.length == 0) { return new Configuration(); }
    return configuration[0];
  }
}

export default new ConfigurationHelper();
